export const casTheme = {
  error: {
    color: 'rgba(226, 29, 29, 1)',
    boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 4px rgba(226, 29, 29, 0.4)'
  }
};
